import dayjs from "dayjs";

/**
 * Get valid attribution data.
 *
 * - Makes sure timestamp is not too old before returning
 * - Adds current page info
 *
 * @param {array} attribution
 * @param {string} pageType
 * @returns {object} validated
 * @returns {boolean} validated.hasAttribution
 * @returns {array} validated.validAttribution
 */
function getValidAttribution(attribution = [], pageType = "form_page") {
  const validated = {
    hasAttribution: false,
    validAttribution: [],
  };

  try {
    if (!attribution.length) {
      throw new Error("No attribution data");
    }

    const timestampAttribute = attribution.find(
      attribute => attribute.param === "timestamp"
    );

    if (!timestampAttribute || !timestampAttribute.value) {
      throw new Error("Missing timestamp attribute");
    }

    const timestamp = dayjs(timestampAttribute.value);
    const expired = dayjs().subtract(12, "hours");

    if (timestamp.isBefore(expired)) {
      throw new Error();
    }

    validated.hasAttribution = true;
    validated.validAttribution = [
      { param: pageType.toString(), value: window.location.href },
      ...attribution,
    ];
  } catch (err) {}

  return validated;
}

export default getValidAttribution;
